import { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import { Box, IconButton, Button, Typography, Drawer } from '@mui/material';
import Toolbar from '@mui/material/Toolbar';
import MenuIcon from '@mui/icons-material/Menu';
import Logo from './LogoApprenticeship'
import theme from './theme';

function AppplicationBar({ pages, handlePageClick, page, Component, isMobile }) {
    const [drawerOpen, setDrawerOpen] = useState(false);

    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setDrawerOpen(open);
    };

    const handleAvatarClick = (event) => {
        event.stopPropagation();
    };

    const drawerContent = (
        <Box
            sx={{
                width: '50vw',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '1rem',
            }}
            role="presentation"
            onClick={toggleDrawer(false)}
            onKeyDown={toggleDrawer(false)}
        >
            {pages.map((p) => (
                <Button
                    key={p}
                    onClick={() => handlePageClick(p)}
                    sx={{
                        my: 1,
                        color: theme.colors.purple,
                        display: 'block',
                        width: '100%',
                        textAlign: 'center',
                        borderBottom: p === page ? `3px solid ${theme.colors.purple}` : 'none',
                    }}
                >
                    <Typography variant="h6" fontWeight="bold">
                        {p}
                    </Typography>
                </Button>
            ))}
            {isMobile && Component && (
                <div onClick={handleAvatarClick}>
                    <Component />
                </div>
            )}
        </Box>
    );

    return (
        <AppBar
            position="static"  // Normal top positioning in the flow
            sx={{
                width: '100%',            // Full width of its container
                padding: '1rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                backgroundColor: 'white',
                borderRadius: '16px',     // Rounded corners
                boxShadow: '0px 2px 4px rgba(0,0,0,0.1)', // subtle shadow
            }}
        >
            <Toolbar
                disableGutters
                sx={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'space-between', // push left and right to edges
                    alignItems: 'center',
                }}
            >
                {/* Left: Logo */}
                <Box sx={{ flexGrow: 0 }}>
                    <Logo style={{ width: isMobile ? '250px' : '350px' }} />
                </Box>

                {/* Right: Pages + Avatar */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                    {!isMobile && (
                        <Box sx={{ display: 'flex', gap: 2 }}>
                            {pages.map((p) => (
                                <Button
                                    key={p}
                                    onClick={() => handlePageClick(p)}
                                    sx={{
                                        color: theme.colors.purple,
                                        fontSize: '1rem',
                                        fontWeight: theme.typography.fontWeightBold,
                                        borderBottom: p === page ? `2px solid ${theme.colors.purple}` : 'none',
                                        '&:hover': {
                                            color: theme.colors.lightPurple,
                                        },
                                    }}
                                >
                                    {p}
                                </Button>
                            ))}
                        </Box>
                    )}

                    {/* Avatar / Menu */}
                    {!isMobile && Component && <Component />}
                    {isMobile && (
                        <IconButton edge="end" aria-label="menu" onClick={toggleDrawer(true)}>
                            <MenuIcon sx={{ color: theme.colors.purple }} />
                        </IconButton>
                    )}
                </Box>
            </Toolbar>

            {/* Drawer for Mobile */}
            <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
                {drawerContent}
            </Drawer>
        </AppBar>
    );
}

export default AppplicationBar;